module.exports = __webpack_public_path__ + "Flaticon.25ea35c11a203a65e0d8.eot";


//////////////////
// WEBPACK FOOTER
// J:/Dev/Workspaces/NovaSingular/JulianaGimenez/angular/src/assets/metronic/src/vendors/flaticon/fonts/Flaticon.eot
// module id = ../../../../../src/assets/metronic/src/vendors/flaticon/fonts/Flaticon.eot
// module chunks = styles